        <div [formGroup]="formGroup">
        <section>
          <div class="block-header">
            <div class="block-number">1</div>
            <div class="block-header-text">
              <p class="block-title">Datos de la solicitud</p>
              <p class="block-caption">Información inicial de la cotización.</p>
            </div>
            <div class="block-action" *ngIf="false">
              <!-- Botón "Nuevo File" removido: sin creación de cliente ya no se ofrece crear file desde acá. -->
            </div>
          </div>
          <div class="block-body">
            <div class="row">
              <div class="col-12 d-flex align-items-center mb-2" style="gap: 1em">
                <label class="field-label mb-0" style="min-width: 140px">Tipo de solicitud</label>
                <div class="d-flex" style="gap: 1.5em">
                  <label class="option-item flex-row-reverse mb-0" style="padding: 0.25rem 0; gap: 10px">
                    <span class="custom-checkbox">
                      <input type="radio" formControlName="requestType" name="requestType" value="quotation" [disabled]="edit" />
                      <span class="checkbox-visual"></span>
                    </span>
                    <span class="option-label">Cotización</span>
                  </label>
                  <label class="option-item flex-row-reverse mb-0" style="padding: 0.25rem 0; gap: 10px">
                    <span class="custom-checkbox">
                      <input type="radio" formControlName="requestType" name="requestType" value="reservation" [disabled]="edit" />
                      <span class="checkbox-visual"></span>
                    </span>
                    <span class="option-label">Reserva</span>
                  </label>
                  <label class="option-item flex-row-reverse mb-0" style="padding: 0.25rem 0; gap: 10px">
                    <span class="custom-checkbox">
                      <input type="radio" formControlName="requestType" name="requestType" value="on_hold" [disabled]="edit" />
                      <span class="checkbox-visual"></span>
                    </span>
                    <span class="option-label">Lista de espera</span>
                  </label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-6 position-relative">
                <label class="field-label">File <span class="required-marker">*</span></label>
                <input
                  type="text"
                  class="form-control field-input mb-2"
                  id="fileSearchInput"
                  name="fileSearchInput"
                  placeholder="{{ loadingFiles ? 'Cargando files...' : 'Buscar file por título o cliente...' }}"
                  [disabled]="edit || showNewFileNameInput"
                  [matAutocomplete]="autoFile"
                  [ngModel]="selectedFile"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="fileChange.emit($event)"
                  (input)="fileSearchInput.emit($any($event.target).value)"
                  autocomplete="off"
                />
                <span
                  *ngIf="formGroup.get('file_id')?.invalid && formGroup.get('file_id')?.touched"
                  class="field-error"
                  data-form-invalid="hotel"
                >
                  {{ requiredFieldMessage('hotel', 'file_id') }}
                </span>
                <mat-autocomplete
                  #autoFile="matAutocomplete"
                  [displayWith]="getFileLabel"
                  (optionSelected)="fileChange.emit($event.option.value)"
                >
                  <mat-option *ngFor="let f of existingFiles" [value]="f" [disabled]="f.__noResults">
                    <span *ngIf="!f.__noResults" style="font-family: &quot;Rubik&quot;, serif; font-size: 14px">
                      {{ getFileLabel(f) }}
                    </span>
                    <span *ngIf="f.__noResults" style="font-family: &quot;Rubik&quot;, serif; font-size: 12px; color: #999">
                      {{ f.__label }}
                    </span>
                  </mat-option>
                </mat-autocomplete>
                <div
                  *ngIf="selectedFileId && !edit"
                  class="mt-1"
                  style="font-family: &quot;Rubik&quot;, serif; font-size: 12px; color: #2f9e5f"
                >
                  Seleccionado: {{ getFileLabel(selectedFile) }}
                  <button
                    type="button"
                    (click)="clearSelectedFile.emit()"
                    style="border: none; background: transparent; color: #999; padding: 0 0 0 6px; font-size: 14px; line-height: 1"
                  >
                    ×
                  </button>
                </div>
              </div>
              <div class="col-6 d-flex flex-column" *ngIf="!edit && (formGroup.get('requestType')?.value === 'reservation' || formGroup.get('requestType')?.value === 'on_hold')">
                <label class="field-label">Pasajero <span class="required-marker">*</span></label>

                <ng-container *ngIf="!loadingPax && availablePax && availablePax.length > 0">
                  <select
                    class="form-control field-input"
                    style="height: 53px !important;"
                    [ngModel]="formGroup.get('passenger.id')?.value"
                    (ngModelChange)="passengerIdChange.emit($event)"
                    [ngModelOptions]="{ standalone: true }"
                  >
                    <option [ngValue]="null">Seleccionar pasajero</option>
                    <option *ngFor="let p of availablePax" [ngValue]="p.idUnique">
                      {{ p.first_name }} {{ p.last_name }} - {{ p.type === 'children' ? 'Niño' : 'Adulto' }}{{ p.age ? ' (' + p.age + ' años)' : '' }}
                    </option>
                  </select>
                </ng-container>

                <ng-container *ngIf="!loadingPax && (!availablePax || availablePax.length === 0)" formGroupName="passenger">
                  <div class="d-flex" style="gap: 1em">
                    <div class="position-relative" style="width: 50%">
                      <input
                        type="text"
                        class="form-control field-input"
                        placeholder="Nombre"
                        formControlName="first_name"
                        maxlength="50"
                        [readonly]="edit"
                      />
                      <span *ngIf="formGroup.get('passenger')?.get('first_name')?.invalid && formGroup.get('passenger')?.get('first_name')?.touched" class="field-error">
                        Ingresá el nombre del pasajero.
                      </span>
                    </div>
                    <div class="position-relative" style="width: 50%">
                      <input
                        type="text"
                        class="form-control field-input"
                        placeholder="Apellido"
                        formControlName="last_name"
                        maxlength="50"
                        [readonly]="edit"
                      />
                      <span *ngIf="formGroup.get('passenger')?.get('last_name')?.invalid && formGroup.get('passenger')?.get('last_name')?.touched" class="field-error">
                        Ingresá el apellido del pasajero.
                      </span>
                    </div>
                  </div>
                </ng-container>

                <span *ngIf="loadingPax" class="field-error" style="color: #666">
                  Cargando pasajeros...
                </span>

                <span *ngIf="formGroup.get('passenger')?.hasError('passengerRequired') && formGroup.get('passenger')?.touched" class="field-error">
                  Seleccioná un pasajero o ingresá nombre y apellido.
                </span>
              </div>
            </div>


            <div class="col-12">
              <!-- Bloque "Crear nuevo File" removido: sin selector de cliente no creamos clientes nuevos. -->
            </div>

            <!-- Bloque "Datos del nuevo cliente" removido: el cliente se resuelve desde el pasajero seleccionado. -->
          </div>
        </section>
        </div>
